import { RefObject } from 'react';

import { useGesture } from '@use-gesture/react';

import { FULL_RANGE_RULER_WIDTH_PX } from '../types/constants';

export interface DragRowsProps {
	handleDrag: (xDelta: number, yDelta: number) => void;
	target: RefObject<Element>;
}
const useDragRows = ({ handleDrag, target }: DragRowsProps): void => {
	useGesture(
		{
			onMouseDown: ({ event }) => {
				event.preventDefault(); //prevent selection of DOM elements if we drag outside
			},
			onDrag: ({ delta: [xDelta, yDelta], event: event, first: first, cancel: cancel, canceled: canceled }) => {
				if (target.current) {
					const clientRect = target.current.getBoundingClientRect();
					if ((event as PointerEvent | MouseEvent).clientX) {
						const pointerEvent = event as PointerEvent;
						if (
							pointerEvent.clientX - clientRect.left >= clientRect.width - FULL_RANGE_RULER_WIDTH_PX &&
							first
						) {
							cancel();
						} else if (!canceled) {
							handleDrag(xDelta, yDelta);
						}
					}
				}
			},
		},
		{
			target,
			drag: {
				threshold: 3, // Require 3px drag before firing, to be more forgiving when a mouse click is intended.
				pointer: {
					capture: false,
				},
			},
			eventOptions: {
				passive: false,
			},
		},
	);
};

export default useDragRows;
